import React from 'react'
import { relativeDate } from '../../lib/utils/common'
import { AnchorLink } from './index'

export const ContentSummary = ({
  date = '',
  source = '',
  href = '#',
  headline = '',
  description = ''
}) => {

  return (
    <header>
      {
        (date || source) &&
        <div className="meta">
          <span className="timestamp" data-behavior="date_time" data-date={date}>
            <span className="date" data-dateformat="date2">{relativeDate(new Date(date))}</span>
          </span>
          <span className="author">
            <span>{source}</span>
          </span>
        </div>
      }
      {
        headline &&
        <h1>
          <AnchorLink trackingName={'&lpos=:editorial'} to={href} text={headline} />
        </h1>
      }
      {
        description && <p>{description}</p>
      }
    </header>
  )

}

export default ContentSummary



/** WEBPACK FOOTER **
 ** ../app/components/common/ContentSummary.jsx
 **/